import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {SearchResultsFilterModel} from "../../shared/models/search/results/filters/search-results-filter.model";
import {SearchResultItemModel} from "../../shared/models/search/results/items/search-result-item.model";
import {ApiResultDispatcherService} from "../../shared/services/api/api-result-dispatcher.service";
import {ApiService} from "../../shared/services/api/api-service";
import {WindowRefService} from "../../shared/services/window-ref.service";
import {ContentSearchParamsModel} from "../models/search-params/content-search-params.model";
import {ContentSearchParamsFactoryService} from "./factories/content-search-params-factory.service";
import {ScopedSearchResultModel} from "../models/search-results/scoped-search-result.model";
import {ShoppingHistoryService} from "../../shared/services/shopping-history.service";

@Injectable({
    providedIn: "root"
})
export class ContentSearchService {
    private API_BASE_URL = "/umbraco/api";

    private API_GET_SEARCH_RESULTS_URL = `${this.API_BASE_URL}/searchApi/getSearchResults`;

    public constructor(
        private windowService: WindowRefService,
        private apiService: ApiService,
        private apiDispatcherService: ApiResultDispatcherService,
        private searchParamsFactory: ContentSearchParamsFactoryService,
        private shoppingHistoryService: ShoppingHistoryService,
    ) {
    }

    public getSearchResult(params: ContentSearchParamsModel): Observable<ScopedSearchResultModel<SearchResultItemModel, SearchResultsFilterModel>> {
        this.updateQueryString(params);
        this.shoppingHistoryService.saveCurrentPage().subscribe(r => {});

        let http = this.apiService.get<ScopedSearchResultModel<SearchResultItemModel, SearchResultsFilterModel>>(
            this.API_GET_SEARCH_RESULTS_URL, {
                searchParams: JSON.stringify(params)
            }
        );

        http = this.apiDispatcherService.dispatchNetworkErrorNotification(http);

        return http;
    }

    private updateQueryString = (params: ContentSearchParamsModel) => {
        const serializedParams = this.searchParamsFactory.serialiseToQueryString(params);
        WindowRefService.setQueryString(serializedParams);
    }
}
